import api from './api';

export const saqueService = {
  // Barbeiro: Solicitar saque
  solicitarSaque: async (formData) => {
    // Não definir Content-Type - o navegador define automaticamente para FormData
    const response = await api.post('/saques/solicitar', formData);
    return response;
  },

  // Barbeiro: Meus saques
  meusSaques: async () => {
    const response = await api.get('/saques/meus');
    return response; // api.get já retorna o JSON parseado diretamente
  },

  // Gestor: Saques pendentes
  saquesPendentes: async () => {
    const response = await api.get('/saques/pendentes');
    return response.data;
  },

  // Gestor: Aprovar saque
  aprovarSaque: async (id, formData) => {
    // Não definir Content-Type - o navegador define automaticamente para FormData
    const response = await api.post(`/saques/aprovar/${id}`, formData);
    return response;
  },

  // Gestor: Rejeitar saque
  rejeitarSaque: async (id, observacao) => {
    const response = await api.post(`/saques/rejeitar/${id}`, { observacao });
    return response.data;
  },

  // Gestor: Enviar comissão manual
  enviarComissao: async (formData) => {
    // Não definir Content-Type - o navegador define automaticamente para FormData
    const response = await api.post('/saques/enviar', formData);
    return response;
  },

  // Gestor: Histórico geral
  historicoGeral: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.get('/saques/historico', { params });
    return response.data;
  }
};

export default saqueService;
